import apiClient from '../apiClient';

const cargosServices = {
  obtenerCargos: async () => {
    try {
      const response = await apiClient.get(`/cargos`);

      return response.data;      
    } catch (error) {
      throw error;
    }
  },
  obtenerCargoPorId: async (id) => {
    try {
      const response = await apiClient.get(`/cargos/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  actualizarCargo: async (id, params) => {
    try {
      const response = await apiClient.put(`/cargos/${id}`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearCargo: async (params) => {
    try {
      const response = await apiClient.post(`/cargos/`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarCargo: async (id) => {
    try {
      const response = await apiClient.delete(`/cargos/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default cargosServices;
